import { render } from "./PrivateFeedback.vue?vue&type=template&id=059d87ab"
import script from "./PrivateFeedback.vue?vue&type=script&lang=js"
export * from "./PrivateFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__